import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONSTANSTS } from '@core/constants';
import { Observable } from 'rxjs';

@Injectable()
export class EventLogService {

  constructor(private http: HttpClient) { }
  /* */
  getHardwareEventLogs(param: any): Observable<any> {
    return this.http.get<any>(CONSTANSTS.api.eventLogs.getHardwareEventLogs, { params: param });
  }

  importExcelEventLogs(param: any): Observable<any> {
    return this.http.post(CONSTANSTS.api.eventLogs.importExcelEventLogs, param);
  }
}
